module.exports = __webpack_public_path__ + "webfonts/398F09_0_0.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/webfonts/398F09_0_0.woff2
// module id = 57
// module chunks = 0